import React from "react";
import { observer } from "mobx-react";
import { AccountSettingsSideMenu } from "@features/administration/account-settings/account-settings-navigation/desktop";
import { useRootAppStore } from "@hooks";
import { isGamesTheme } from "@utils";
import {
	AdministrationSideMenuItem,
	PlayerInfoCenterItem,
	AdministrationSideMenuItemLong,
} from "./components";
import { useTranslation } from "react-i18next";
import { THEME_SETTINGS } from "@theme-settings";
import { useAppContext } from "@state/hooks/shared";

export default observer(function AdministrationSideMenu(props: {
	isUserSettingsActive?: boolean;
}) {
	const user = useRootAppStore().userAuthStore;
	const { t } = useTranslation("account-settings-navigation");
	const { culture } = useAppContext();

	return (
		<>
			<nav className="nav--secondary nav--account">
				<ul className="nav--secondary__menu nav--account__menu">
					{!isGamesTheme() && (
						<AdministrationSideMenuItem
							path={`/${culture}/my-bets`}
							styling="my-bets"
							translation={t("HEADER.MY_BETS")}
						/>
					)}
					<AdministrationSideMenuItemLong
						path={`/${culture}/account-statement`}
						styling="account-statement"
						translation={t("HEADER.ACCOUNT_STATEMENT")}
					/>

					{user.isInternetUser ? (
						<>
							<AdministrationSideMenuItem
								path={`/${culture}/deposit`}
								styling="deposit"
								translation={t("DEPOSIT.TITLE")}
							/>
							<AdministrationSideMenuItem
								path={`/${culture}/withdrawal`}
								styling="withdrawal"
								translation={t("WITHDRAWAL.TITLE")}
							/>
						</>
					) : null}

					{WEBPACK_IS_CASINO_ENABLED ||
					WEBPACK_IS_CASINO_LIVE_ENABLED ? (
						<AdministrationSideMenuItemLong
							path={`/${culture}/gaming-history`}
							styling="gaming-history"
							translation={t("GH_HEAD")}
						/>
					) : null}

					<AdministrationSideMenuItemLong
						path={`/${culture}/account-settings/personal-data`}
						styling="account-settings"
						translation={t("HEADER.ACCOUNT_SETTINGS")}
					/>

					{THEME_SETTINGS.isPlayerInformationCenterEnabled &&
					user?.user?.isPICEnabled ? (
						<PlayerInfoCenterItem
							path={`/${culture}/player-information-center`}
							translation={t("PLAYER_INFORMATION_CENTER")}
						/>
					) : null}
				</ul>
			</nav>

			{props.isUserSettingsActive && <AccountSettingsSideMenu />}
		</>
	);
});
